import React,{ Component } from 'react'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import { enviaContacto } from '../actions'




class Contacto extends Component{

	constructor(props) {
    super(props);
    this.state = {
      imgPrefix:"",
      nombreapellido:"",
      correo:"",
      telefono:"",
      msj:"",
      alert:"",
      se_envio:0,
      envio:false
    }
    this.envia = this.envia.bind(this)
    this.validaForm = this.validaForm.bind(this)
  }

  componentDidMount() {
    console.log(this.props.tipo)
  }

  componentDidUpdate(prevProps, prevState) {
    console.log(this.props.user);
     console.log(this.state);
    if(this.props.user.envio && (!prevProps.user.envio || prevProps.user.envio.momento != this.props.user.envio.momento)){
      console.log("volvio del envio")

      if (this.props.user.envio.resp==1){
        console.log("ENVIO CORRECTAMENTE");
        this.setState({
          nombreapellido: "",
          correo: "",
          telefono: "",
          msj: "",
          alert:"",
          envio:true,
          enviando:false,
        });
      }else{
        console.log("ERROR AL ENVIAR");
        this.setState({
          alert: this.props.user.envio.mensaje,
          envio:false,
          enviando:false
        });
      }
    }
  }

  cambia = (key, value) => {
    this.setState({ [key]: value, enviado: false, alert: "" });
  }

  envia(e){
    const valida = this.validaForm()
    if (valida.resp) {
      const data = {
        nombreapellido:this.state.nombreapellido,
        correo:this.state.correo,
        telefono:this.state.telefono,
        msj:this.state.msj
      }
        this.setState({
          enviando:true,
          enviado:false
        },this.props.enviaContacto(data))
     

    }

    e.preventDefault()
  }

  validaForm = () => {
    if (this.state.nombreapellido == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR SU NOMBRE Y APELLIDO"
      }
    } else if (this.state.correo == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR LA DIRECCION DE MAIL"
      }
    } else if (this.state.telefono == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR EL TELEFONO"
      }
    } else if (this.state.msj == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR EL MENSAJE"
      }
   
    } else {
      return {
        resp: true,
        msj: "PASO LA VALIDACION"
      }
    }
  }


  render() {
		  return (
		  	<section className="container mb-5 sombraHead mt-3 clearfix" >
          {this.state.alert != "" &&
            <div className="alert alert-danger" role="alert">{this.state.alert}</div>
          }
          {this.state.envio &&
          <div className="alert alert-success" role="alert">
            El mensaje fue enviado correctamente, nos contactaremos con usted a la brevedad. Muchas gracias!
          </div>
          }
          <hgroup>
            <h2 className="display-4 text-info tit-font">Contactanos</h2>
            <p className="lead ">Nos complace ayudarlo si hay algo que podamos hacer por usted.</p><p className="lead ">¡Solo póngase en contacto con nosotros!</p>
          </hgroup>

          <div className="row pt-3">
          <section className="col-md-6">
            <ul className="lista-contacto">
                <li><span className="fas fa-phone"></span>&nbsp;&nbsp;0800-222 8358</li>
                <li><span className="fas fa-phone"></span>&nbsp;&nbsp;+54 11 4568-4334</li>
                <li><span className="far fa-envelope"></span>&nbsp;&nbsp;info@velton-accesos.com.ar </li>
                <li><span className="fas fa-map-marker"></span>&nbsp;&nbsp;Elpidio González 3945<p>C1407 Ciudad Aútónoma de Buenos Aires<br/>Montecastro</p></li>
            </ul>
          </section>
          
          <section className="col-md-6">
            <form>
              <div className="form-group">
                <label >Apellido y Nombre</label>
                  <input type="text" className="form-control" id="nombre" placeholder="Apellido y Nombre" onChange={evt => this.cambia('nombreapellido', evt.target.value)} value={this.state.nombreapellido}/>
              </div>
              <div className="form-group">
                <label >Dirección de Mail</label>
                  <input type="email" className="form-control" id="correo" aria-describedby="emailHelp" placeholder="Dirección de Mail" onChange={evt => this.cambia('correo', evt.target.value)} value={this.state.correo}/>
              </div>
              <div className="form-group">
                <label >Teléfono</label>
                  <input type="text" className="form-control" id="telefono" placeholder="Teléfono" onChange={evt => this.cambia('telefono', evt.target.value)}  value={this.state.telefono}/>
              </div>
              <div className="form-group">
                <label >Mensaje</label>
        <textarea className="form-control" id="msj" rows="3" onChange={evt => this.cambia('msj', evt.target.value)} value ={this.state.msj} ></textarea>
              </div>
              {!this.state.enviando ?
              <button type="submit" className="btn btn-primary" onClick={this.envia} >Enviar</button>
              :
              <h4>ENVIANDO...</h4>
              }
            </form>
          </section>
          </div>
        </section>
		  )
	  }
}

const mapStateToProps = (state, ownProps) => {
  return {
      user: state.usuario
    }
}

const mapDispatchToProps = dispatch => {
  return {
    enviaContacto: (datos) => {
      dispatch(enviaContacto(datos))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contacto)




// WEBPACK FOOTER //
// ./src/containers/contacto.js